import { FC } from 'react'
import Tooltip from '@organisms/Tooltip'
import InfoCounter from '@organisms/InfoCounter'
import { formatServerDate } from '@utils/date'
import Text from '@organisms/Text'
import COURSE_TYPES from '@const/courseTypes'
import COURSE_SUB_TYPES from '@const/courseSubTypes'
import manyWords from '@utils/manyWords'
import { CourseSubTypes, CourseTypes } from '@models/course'
import { useAppSelector } from '@hooks/useAppSelector'
import { DateAlertWrapper, LineWrapper } from './styled'

type Props = {
  withDeadlineBadge: boolean
  createdAt: string | undefined
  deadlineAt: string | undefined
  type: CourseTypes
  subType: CourseSubTypes
  hoursCount: number
  index?: number
  hideHours?: boolean
}

const CourseInfo: FC<Props> = ({
  withDeadlineBadge,
  createdAt,
  deadlineAt,
  type,
  subType,
  hoursCount,
  index,
  hideHours = false,
}) => {
  const onboardingStarted = useAppSelector((state) => state.onboarding.started)
  const typeLabel = COURSE_TYPES.find(({ value }) => type === value)?.label
  const subTypeLabel = COURSE_SUB_TYPES.find(({ value }) => subType === value)?.label

  const needShowDeadline = withDeadlineBadge && createdAt && deadlineAt

  return (
    <LineWrapper>
      {onboardingStarted && !needShowDeadline && index === 0 && (
        <DateAlertWrapper>
          <InfoCounter id="deadlineBlock">01.01.2010 / 01.01.2020</InfoCounter>
        </DateAlertWrapper>
      )}
      {needShowDeadline && (
        <DateAlertWrapper>
          <Tooltip tooltipContent="Указана дата назначения и рекомендованная дата окончания обучения. Курс будет доступен и после.">
            <InfoCounter id="deadlineBlock">
              {formatServerDate(createdAt) +
                ' / ' +
                formatServerDate(deadlineAt)}
            </InfoCounter>
          </Tooltip>
        </DateAlertWrapper>
      )}
      {typeLabel ? <Text type="tag">{typeLabel}</Text> : null}
      {subTypeLabel ? <Text type="tag">{subTypeLabel}</Text> : null}
      {!hideHours && (
        <Text type="tag">{manyWords(hoursCount, 'час', 'часа', 'часов')}</Text>
      )}
    </LineWrapper>
  )
}

export default CourseInfo
